import { Adjustment, AdjustmentCategory, NextArray } from 'type';

const filterWithCategory = (
  adjustments: NextArray<Adjustment>,
  category: AdjustmentCategory
) => adjustments.filter((adjustment) => adjustment.category === category);

const getFactorsWithSlug = (
  adjustments: NextArray<Adjustment>,
  category: AdjustmentCategory,
  slug?: string
) => {
  const adjustment = adjustments.find(
    (_adjustment) => _adjustment.slug.current === slug
  );

  if (adjustment) {
    return adjustment;
  }

  const [filteredAdjustment] = filterWithCategory(adjustments, category);

  return adjustment || filteredAdjustment;
};

export const AdjustmentUtil = {
  filterWithCategory,
  getFactorsWithSlug,
};
